import React from "react";
import { motion } from "framer-motion";

/**
 * GlassCard - Componente reutilizable con efecto liquid glass (iOS 26 style)
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Contenido de la tarjeta
 * @param {string} [props.className] - Classes adicionales para el contenedor
 * @param {Object} [props.hoverAnimation] - Animación personalizada para hover (default: { x: 4, y: -2 })
 * @param {boolean} [props.showOverlay=true] - Mostrar el overlay con gradiente
 * @param {string} [props.image] - URL de imagen opcional para mostrar en la parte superior
 * @param {string} [props.imageAlt] - Texto alternativo para la imagen
 * @param {Object} [props.imageClassName] - Classes adicionales para la imagen
 */
const GlassCard = ({
    children,
    className = "",
    hoverAnimation = { x: 4, y: -2 },
    showOverlay = true,
    image,
    imageAlt = "",
    imageClassName = "",
    ...props
}) => {
    return (
        <motion.div
            className={`relative p-6 rounded-3xl bg-gradient-to-br from-white/50 via-white/40 to-white/30 dark:from-gray-800/40 dark:via-gray-800/30 dark:to-gray-900/20 backdrop-blur-2xl border border-white/30 dark:border-white/10 shadow-[0_8px_32px_-8px_rgba(0,0,0,0.12),0_0_0_1px_rgba(255,255,255,0.15)_inset] dark:shadow-[0_8px_32px_-8px_rgba(0,0,0,0.4),0_0_0_1px_rgba(255,255,255,0.08)_inset] hover:shadow-[0_12px_40px_-8px_rgba(0,0,0,0.18),0_0_0_1px_rgba(255,255,255,0.2)_inset] dark:hover:shadow-[0_12px_40px_-8px_rgba(0,0,0,0.5),0_0_0_1px_rgba(255,255,255,0.12)_inset] transition-all duration-500 overflow-hidden group ${className}`}
            whileHover={hoverAnimation}
            {...props}
        >
            {/* Imagen opcional */}
            {image && (
                <div className="relative mb-4 -mx-6 -mt-6 overflow-hidden rounded-t-3xl">
                    <img
                        src={image}
                        alt={imageAlt}
                        className={`w-full h-48 object-cover ${imageClassName}`}
                    />
                </div>
            )}

            {/* Subtle gradient overlay */}
            {showOverlay && (
                <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-transparent opacity-50 group-hover:opacity-70 transition-opacity duration-500 pointer-events-none" />
            )}

            {/* Content */}
            <div className="relative z-10">{children}</div>
        </motion.div>
    );
};

export default GlassCard;
